<template>
    <v-container>
        <h1 class="titulo mb-3">PARÂMETROS DO SISTEMA</h1>
        <div>
            <div id="tabs" class="container">
                <div class="tabs">
                    <div><a @click="activetab=GENERAL_CONFIGS" :class="{ active: activetab === GENERAL_CONFIGS }">Configuração Geral</a></div>
                    <div><a @click="activetab=FOR_NOW_GROUPS_CONFIG" :class="{ active: activetab === FOR_NOW_GROUPS_CONFIG }">Configuração de Grupos</a></div>
                    <div><a @click="activetab=PURGE_LOG_CONFIG" :class="{ active: activetab === PURGE_LOG_CONFIG }">Configuração de Expurgo</a></div>
                    <div><a @click="activetab=BANCS_CONFIG" :class="{ active: activetab === BANCS_CONFIG }">Configuração de Bancos</a></div>
                </div>
                <div class="content">
                    <div v-if="activetab === GENERAL_CONFIGS" class="tabcontent">
                        <ConfiguracoesGerais />
                    </div>
                    <div v-if="activetab === FOR_NOW_GROUPS_CONFIG" class="tabcontent">
                        <ConfiguracoesGruposPraJa />
                    </div>
                    <div v-if="activetab === PURGE_LOG_CONFIG" class="tabcontent">
                        <LogPurgeConfig />
                    </div>
                    <div v-if="activetab === BANCS_CONFIG" class="tabcontent">
                        <ConfiguracoesBancos />
                    </div>
                </div>
            </div>
        </div>
    </v-container>
</template>

<script>
  import ConfiguracoesGerais from './ConfiguracoesGerais.vue'
  import ConfiguracoesGruposPraJa from './ConfiguracoesGruposPraJa.vue'
  import LogPurgeConfig from './LogPurgeConfig.vue'
  import ConfiguracoesBancos from './ConfiguracoesBancos.vue'

  export default {
    name: 'ParametrosSistema',
    components: { ConfiguracoesGerais, ConfiguracoesGruposPraJa, LogPurgeConfig, ConfiguracoesBancos },
    data: () => ({
      activetab: 'general_configs',
      detailedQueriesData: ''
    }),
    computed: {
      GENERAL_CONFIGS: () => 'general_configs',
      FOR_NOW_GROUPS_CONFIG: () => 'for_now_groups_config',
      PURGE_LOG_CONFIG: () => 'purge_log_config',
      BANCS_CONFIG: () => 'bancs_config'
    }
  }
</script>

<style scoped lang="scss">
.title-date {
    color: var(--primary);
    font-weight: 800;
}
.listagem th {
    min-width: 90px;
}
.listagem th:nth-of-type(2) {
    min-width: auto;
}
@import url('../../../assets/css/tabs.css');

</style>
